import { NgModule } from '@angular/core';
import {
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
  NgStyle,
  AsyncPipe,
  DatePipe,
  DecimalPipe,
} from '@angular/common';
import {
  MatFormFieldModule,
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_RIPPLE_GLOBAL_OPTIONS,
  RippleGlobalOptions,
} from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDivider } from '@angular/material/divider';

/**
 * Global configuration for Material Ripple effects.
 * This configuration disables ripple effects globally.
 */
const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  terminateOnPointerUp: false, // Optional: Terminate ripple on pointer up
};

const globalMatFormFieldConfig: MatFormFieldDefaultOptions = {
  appearance: 'outline', // Default appearance for form fields
  floatLabel: 'auto', // Always show the floating label
};

@NgModule({
  declarations: [],
  imports: [
    NgClass,
    NgIf,
    NgFor,
    NgStyle,
    AsyncPipe,
    AsyncPipe,
    DatePipe,
    DecimalPipe,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDivider,
    MatOptionModule,
    FormsModule,
    MatSelectModule,
    NgOptimizedImage,
    MatTooltipModule,
    TranslateModule,
  ],
  exports: [
    NgClass,
    NgIf,
    NgFor,
    NgStyle,
    AsyncPipe,
    DatePipe,
    DecimalPipe,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    FormsModule,
    MatDivider,
    MatSelectModule,
    NgOptimizedImage,
    MatTooltipModule,
    TranslateModule,
  ],
  providers: [
    TranslateService,
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: globalMatFormFieldConfig,
    },
  ],
})
export class SharedModule {}
